import { render, staticRenderFns } from "./ValidateTSDetails.vue?vue&type=template&id=558a72a0&scoped=true&"
import script from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
export * from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTSDetails.vue?vue&type=style&index=0&id=558a72a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a72a0",
  null
  
)

export default component.exports